import React from 'react';
import Icon from '../../../components/AppIcon';
import { format } from 'date-fns';

const ReferralTrackingList = ({ referrals = [] }) => {
  const getStatusConfig = (status) => {
    const configs = {
      pending: {
        label: 'Pending',
        icon: 'Clock',
        color: 'var(--color-muted-foreground)',
        bgColor: 'bg-muted',
        textColor: 'text-muted-foreground'
      },
      signed_up: {
        label: 'Signed Up',
        icon: 'UserPlus',
        color: 'var(--color-warning)',
        bgColor: 'bg-warning/10',
        textColor: 'text-warning'
      },
      active_member: {
        label: 'Active Member',
        icon: 'CheckCircle',
        color: 'var(--color-success)',
        bgColor: 'bg-success/10',
        textColor: 'text-success'
      },
      expired: {
        label: 'Expired',
        icon: 'XCircle',
        color: 'var(--color-error)',
        bgColor: 'bg-error/10',
        textColor: 'text-error'
      }
    };
    return configs?.[status] || configs?.pending;
  };

  const getSourceIcon = (source) => {
    const icons = {
      email: 'Mail',
      social_media: 'Share2',
      sms: 'MessageSquare',
      direct: 'Link'
    };
    return icons?.[source] || 'Link';
  };

  if (referrals?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-8 text-center">
        <div className="flex justify-center mb-4">
          <div className="flex items-center justify-center h-16 w-16 rounded-full bg-muted">
            <Icon name="Users" size={32} color="var(--color-muted-foreground)" />
          </div>
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">No Referrals Yet</h3>
        <p className="text-sm text-muted-foreground">
          Start sharing your referral code to invite friends and earn rewards!
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {referrals?.map((referral) => {
        const statusConfig = getStatusConfig(referral?.status);
        
        return (
          <div
            key={referral?.id}
            className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between gap-4">
              {/* Referral Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <h4 className="font-semibold text-foreground truncate">
                    {referral?.referred_name || 'Unknown'}
                  </h4>
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${statusConfig?.bgColor} ${statusConfig?.textColor}`}>
                    <Icon name={statusConfig?.icon} size={12} />
                    {statusConfig?.label}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground mb-2">
                  {referral?.referred_email}
                </p>
                <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Icon name="Calendar" size={12} />
                    <span>Referred {format(new Date(referral?.created_at), 'MMM d, yyyy')}</span>
                  </div>
                  {referral?.referral_source && (
                    <div className="flex items-center gap-1">
                      <Icon name={getSourceIcon(referral?.referral_source)} size={12} />
                      <span className="capitalize">{referral?.referral_source?.replace('_', ' ')}</span>
                    </div>
                  )}
                  {referral?.became_member_at && (
                    <div className="flex items-center gap-1">
                      <Icon name="CheckCircle" size={12} />
                      <span>Member since {format(new Date(referral?.became_member_at), 'MMM d')}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Status Icon */}
              <div className="flex-shrink-0">
                <div className={`flex items-center justify-center h-10 w-10 rounded-full ${statusConfig?.bgColor}`}>
                  <Icon name={statusConfig?.icon} size={20} color={statusConfig?.color} />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReferralTrackingList;